import React from 'react'
import PropTypes from 'prop-types'
import * as Classes from '@blueprintjs/core/lib/cjs/common/classes'
import { Button } from '@blueprintjs/core/lib/cjs/components/button/buttons'
import { Dialog } from '@blueprintjs/core/lib/cjs/components/dialog/dialog'
import { InputGroup } from '@blueprintjs/core/lib/cjs/components/forms/inputGroup'
import styles from './renameActionModal.module.scss'

/**
 * Modal dialog used to rename a template action in draft mode.
 * @param {object} props Component props.
 * @param {boolean} props.isOpen Controls modal visibility.
 * @param {string} props.value Current action name shown in the input.
 * @param {Function} props.onChange Called when the input value changes.
 * @param {Function} props.onCancel Called when the modal is canceled/closed.
 * @param {Function} props.onConfirm Called when rename is confirmed.
 * @returns {JSX.Element}
 */
const RenameActionModal = ({
    isOpen = false,
    value = '',
    onChange,
    onCancel,
    onConfirm,
}) => {
    const isRenameDisabled = !value.trim()

    return (
        <Dialog isOpen={isOpen} title="Rename action" onClose={onCancel}>
            <div className={Classes.DIALOG_BODY}>
                <InputGroup
                    value={value}
                    onChange={onChange}
                    placeholder="Action name"
                    autoFocus
                />
            </div>
            <div className={Classes.DIALOG_FOOTER}>
                <div className={styles.footerActions}>
                    <Button onClick={onCancel} className={styles.cancelButton}>
                        Cancel
                    </Button>
                    <Button
                        intent="primary"
                        onClick={onConfirm}
                        disabled={isRenameDisabled}
                        className={styles.renameButton}
                    >
                        Rename
                    </Button>
                </div>
            </div>
        </Dialog>
    )
}

RenameActionModal.propTypes = {
    isOpen: PropTypes.bool,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
}
export default RenameActionModal
